import React from 'react';
import { Dialog } from '@gravity-ui/uikit';
import { useMonaco } from '../../../../core/components/Form/hooks';
import i18n from '../../../i18n';
import { block } from '../../../utils';
import { MonacoHeader } from './MonacoHeader';
import { useMonacoOptions } from './useMonacoOptions';
import './MonacoInputDialog.css';
const b = block('monaco-input-dialog');
export const MonacoInputDialog = ({ name, value, title, visible, language, onChange, onClose, changeMonacoValue, fontSize, MonacoComponent, }) => {
    const MonacoEditor = useMonaco() || MonacoComponent;
    const handleClose = React.useCallback(() => {
        onChange(value);
        onClose();
    }, [onChange, onClose]);
    const options = useMonacoOptions(fontSize, false);
    if (!MonacoEditor) {
        return null;
    }
    return (React.createElement(Dialog, { open: visible, onClose: handleClose, className: b() },
        React.createElement(Dialog.Header, { caption: title, className: b('dialog-header') }),
        React.createElement(Dialog.Body, null,
            React.createElement("div", { className: b('container'), "data-qa": `${name}-dialog` },
                React.createElement(MonacoHeader, { language: language }),
                React.createElement(MonacoEditor, { language: language, height: "600", width: "900", value: value, onChange: changeMonacoValue, options: options }))),
        React.createElement(Dialog.Footer, { textButtonApply: i18n('button_cancel'), onClickButtonApply: handleClose })));
};
